export default __webpack_public_path__ + "media/images/react_icons/property/parking_light-c065fc341f0e0a0af6f24fd66547e30b.svg";